/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router";
import {
  Button,
  Form,
  SelectionField,
  MultiSelectionField,
  InputField,
  MultiSelectField,
  RadioInputField,
  TextAreaField,
  RichTextField,
  VisualizationAttr,
  Spinner,
  
  
} from "@/commons/components";
import {
  ALLOWED_PERMISSIONS,
  findAllowedPermission,
} from "@/commons/constants/allowedPermission";
import cleanFormData from "@/commons/utils/cleanFormData";
import updateKelasDosen from '../services/updateKelasDosen'

import { notifyError, notifySuccess} from "@/commons/utils/toaster";
import * as Layouts from "@/commons/layouts";

const FormUbahDosenKelas = ({ 
	dosenKelasData
, 	dosen
 }) => {
  const { 
    control, 
    handleSubmit,
  } = useForm({ defaultValues: dosenKelasData })
  
  
  
  
  const navigate = useNavigate()
  
  const simpan = (data) => {
    const cleanData = cleanFormData(data)
    updateKelasDosen({
      ...cleanData,
    })
    .then(({ data: { data } }) => {
     navigate(`/kelas/${dosenKelasData.kelasId}`)
  	notifySuccess(`Update Kelas Dosen berhasil!`);
    })
    .catch((error) => {
      console.error(error);
          notifyError(error);
    });
  }
  
  
  return (
	<div>
	  <Layouts.FormComponentLayout
		  title="Ubah Dosen Kelas" 
		  onSubmit={handleSubmit(simpan)}
	
	    vas={[
		  ]}
	
		  formFields={[

			  <Controller
				key="dosenId"
				name="dosenId"
				control={control}
				render={({ field, fieldState }) => (
						<SelectionField
					
					label="Dosen"
					options={dosen}
					optionKey="dosenId"
					optionLabel="dosen"
					placeholder="Masukkan dosen"
						fieldState={fieldState}
						defaultValue={dosenKelasData.dosenId}
					{...field}
						isRequired={false}
				/>
		
				)}
			  />
			,
			  
			  <Controller
			    key="bobot"
		        name="bobot"
		        control={control}
		        render={({ field, fieldState }) => (
				  <InputField
		            label="Bobot"
		            placeholder="Masukkan bobot"
					type="number"
		            defaultValue={dosenKelasData.bobot}	            fieldState={fieldState}
					{...field}
					isRequired={false}
		          />
		        )}
		      />	  
		  ]}
	
		  itemsEvents={[
				<Button id="_kRy7EC5hEfCJ1YDat3KRPQ" key="Simpan" type="submit" variant="primary">Simpan</Button>
	    ]}
	  />
	    
	</div>
  )
}

export default FormUbahDosenKelas
